var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.959 23.416h12.5v-2.083h2.083v3.125a.984.984 0 0 1-1.041 1.041H1.917a.983.983 0 0 1-1.041-1.041V1.54A.984.984 0 0 1 1.917.499h14.584a.985.985 0 0 1 1.041 1.042v3.125H15.46V2.583h-12.5v20.833ZM13.375 6.75 20.667 13l-7.292 6.25v-5.208H6.084v-2.084h7.291V6.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign_out.08d3167ed5953a3dff764119cf9dd995.svg";
export { ForwardRef as ReactComponent };